import React from 'react';
import { Link } from '@naf-simba/elements-links';
import { Typography } from '@naf-simba/building-blocks-typography';
import BlockContent from '@components/block-content/BlockContent';
import { useAuth0Token } from '../../../hooks/useAuth0Token';
import { useDocumentData } from '../../../hooks/Documents/useDocumentData';
import { ArticleType } from '../../../../../types/articleType';
import { CompetitionStyleVariant } from '../Competition.types';
import * as S from '../Competition.styles';

const TERMS_TEXT = {
  close: 'Lukk',
  error: 'Kunne ikke laste vilkår.',
  loading: 'Laster vilkår...',
};

interface CompetitionTermsAndConditionsProps {
  style: CompetitionStyleVariant;
  termsLinkSlug: string;
  onHideTerms: () => void;
}

const CompetitionTermsAndConditions = ({ style, termsLinkSlug, onHideTerms }: CompetitionTermsAndConditionsProps) => {
  const { simpleToken } = useAuth0Token();
  const { meta, data: termsData } = useDocumentData(termsLinkSlug, simpleToken);
  const { name, ingress, body } = (termsData as ArticleType | undefined) ?? ({} as Partial<ArticleType>);
  const isInverted = style === 'spruce';
  const isLoadingTerms = !body && meta.isUpdating;
  const hasTermsError = !body && meta.isUpdating === false;

  return (
    <S.TermsContent>
      {name && (
        <S.TermsTitle>
          <Typography variant="headlineXS">{name}</Typography>
        </S.TermsTitle>
      )}
      {ingress && (
        <S.Ingress>
          <Typography variant="textMRegular">{ingress}</Typography>
        </S.Ingress>
      )}
      {body && <BlockContent value={body} />}
      {isLoadingTerms && <Typography variant="textMRegular">{TERMS_TEXT.loading}</Typography>}
      {hasTermsError && <Typography variant="textMRegular">{TERMS_TEXT.error}</Typography>}
      <S.LinkWrapper>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- Link used as a non-navigating action */}
        <Link onClick={onHideTerms} text={TERMS_TEXT.close} inverted={isInverted} />
      </S.LinkWrapper>
    </S.TermsContent>
  );
};

export default CompetitionTermsAndConditions;
